import React, { memo, useCallback } from 'react';
import { View } from 'react-native';
import { AppView } from 'design-system';
import ConnectionFailed from 'design-system/ConnectionFailed';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { updateWealthAccounts } from '../actions';
import { NavigationHeaderWithAvatar } from './NavigationHeaderWithAvatar';
const ConnectionFailedView = () => {
    const dispatch = useAppDispatch();
    const { paddingHorizontalStyle } = useAppFrameDimensions(true);
    const isFetchingWealthAccounts = useAppSelector((state) => state.unpersistedInvestReducer.isFetchingWealthAccounts);
    const handleTryAgain = useCallback(() => {
        dispatch(updateWealthAccounts());
    }, []);
    return (<AppView withFrame={false}>
      <NavigationHeaderWithAvatar showTitle={false}/>
      <View style={paddingHorizontalStyle}>
        <ConnectionFailed handleTryAgain={handleTryAgain} requesting={isFetchingWealthAccounts}/>
      </View>
    </AppView>);
};
export default memo(ConnectionFailedView);
